import * as React from 'react'

function SvgLogoGrafenoCompact() {
  return (
    <svg
      width="34"
      height="40"
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.2788 12.7475C31.7207 12.6295 31.9566 13.2489 31.5591 13.4555L18.6099 20.1967C18.1975 20.4033 18.4629 21.0376 18.9048 20.8901L25.3277 18.7807C25.6517 18.6629 25.9457 19.0022 25.7837 19.312L15.4575 39.1684C15.3102 39.4339 14.9271 39.4487 14.7798 39.1684L4.35012 19.2084C4.23256 18.9725 4.38008 18.6774 4.63039 18.6479C9.21177 18.043 17.3139 16.5093 31.2788 12.7475ZM32.5904 0.0160581C32.9732 -0.0869455 33.2974 0.326248 33.1206 0.665472C33.0983 0.71103 30.2091 6.61404 30.1304 6.66938C24.7683 9.69359 13.3215 13.7499 3.45168 15.9038C2.96578 15.2543 0.0605635 9.22977 0.0493373 9.20649C-0.0832042 8.94102 0.0635495 8.61631 0.343283 8.54243C0.343283 8.54243 5.7794 8.45453 15.2661 6.50727C22.6464 5.00254 32.5904 0.0160581 32.5904 0.0160581Z"
        fill="#00BBA7"
      />
    </svg>
  )
}

export default SvgLogoGrafenoCompact
